$(document).ready(function () {
  // Écoute des clics sur tous les éléments ayant l'attribut 'data-url_target'
  $(document).on("click", "[data-url_target]", function (e) {
    var url = $(this).data("url_target");
    window.location.href = url;
    return false;
  });

  // Gestion du menu (desktop)
  // Écoute des clics sur les éléments du menu (lien dont l'attribut aria-controls contient menu_drawer_*)
  $(".main_menu [aria-controls^='menu_drawer_']").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Récupération de la target sous menu
    var $target = $("#" + $(this).attr("aria-controls"));

    var $drawer = $(".main_navigation");

    // Si le menu est fermé (aria-expanded = false)
    if ($drawer.attr("data-visible") == "false") {
      // On l'ouvre
      $drawer.attr("data-visible", "true");

      // On ajoute la class "no-scroll" sur le body pour empêcher le scroll
      $("body").addClass("no-scroll");

      // On place l'ensemble des éléments qui controle le drawer en aria-expanded = true
      $("[aria-controls='menu_drawer']").attr("aria-expanded", "true");
    }

    // On ouvre de la même facon la $target
    $target.attr("data-visible", "true");

    // On ferme tous les autres sous menu
    $drawer.find("[data-visible]").not($target.get(0)).attr("data-visible", "false");

    // Ansi que ces enfants
    $("#" + $target.attr("id") + " [aria-controls]").attr("aria-expanded", "true");
    $target.find("[data-visible='false']").attr("data-visible", "true");

    // On place l'ensemble des éléments qui controle le menu ouvert en aria-expanded = true
    $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "true");

    // On place l'ensemble des éléments qui contrôle les sous menu fermés en aria-expanded = false
    $drawer
      .find("[aria-controls^='menu_drawer_']")
      .not("[aria-controls='" + $target.attr("id") + "']")
      .attr("aria-expanded", "false");
  });

  // Gestion des liens dans le menu drawer ouver
  $(".main_navigation [aria-controls^='menu_drawer_']").click(function (e) {
    e.preventDefault();

    var $target = $("#" + $(this).attr("aria-controls"));
    if ($target.attr("data-visible") == "true") {
      // On place l'ensemble des éléments qui controle le menu fermé en aria-expanded = false
      $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "false");
      $target.attr("data-visible", "false").hide();
    } else {
      // Si on est en desktop
      $target.parents("ul").first().find("[data-visible]").not($target.get(0)).attr("data-visible", "false").hide();

      if (window.innerWidth > 989) {
        // On ouvre les sous-menu associés à la target
        $("#" + $target.attr("id"))
          .find("[data-visible='false'][data-open-first-desktop='true']")
          .attr("data-visible", "true")
          .show();

        // On place l'ensemble des éléments qui controle le menu ouvert en aria-expanded = true
        $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "true");
      } else {
        // On ouvre les sous-menu associés à la target
        $("#" + $target.attr("id"))
          .find("[data-visible='false'][data-open-first-mobile='true']")
          .attr("data-visible", "true")
          .show();

        // On place l'ensemble des éléments qui controle le menu ouvert en aria-expanded = true
        $("[aria-controls='" + $target.attr("id") + "']").attr("aria-expanded", "true");
      }

      // On place l'ensemble des éléments qui contrôle les sous menu fermés en aria-expanded = false
      $target
        .parents("ul")
        .first()
        .find("[aria-controls^='menu_drawer_']")
        .not("[aria-controls='" + $target.attr("id") + "']")
        .attr("aria-expanded", "false");

      $target.slideDown(200, function () {
        $target.attr("data-visible", "true");
      });
    }
  });

  // Si on clique en dehors du menu, on le ferme, et qu'on ne clique sur élément du menu ([aria-controls^='menu_drawer_'])
  $(document).click(function (e) {
    if (!$(e.target).closest(".main_navigation nav").length || $(e.target).parents(".close_menu").length) {
      // On place l'ensemble des éléments qui controle le drawer en aria-expanded = false
      $("[aria-controls='menu_drawer']").attr("aria-expanded", "false");

      // On place l'ensemble des éléments qui contrôle les sous menu fermés en aria-expanded = false
      $("[aria-controls^='menu_drawer_']").attr("aria-expanded", "false");

      // Fermeture du menu
      $(".main_navigation").attr("data-visible", "false");
      $(".main_navigation [data-visible]").attr("data-visible", "false");
      $("body").removeClass("no-scroll");
    }
  });

  // Si on ne clique pas sur un élément du menu, on le ferme
  $("[aria-controls^='menu_drawer_']").click(function (e) {
    e.stopPropagation();
  });

  // Lien permettant d'ouvrir le menu sur mobile
  $("[aria-controls='menu_drawer']")
    .not(".close_menu")
    .click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      // On place l'ensemble des éléments qui controle le drawer en aria-expanded = true
      $("[aria-controls='menu_drawer']").attr("aria-expanded", "true");

      // Fermeture du menu
      $(".main_navigation").attr("data-visible", "true");

      // On ajoute la class "no-scroll" sur le body pour empêcher le scroll
      $("body").addClass("no-scroll");
    });

  // Fiche produit, scroll pour afficher le footer fixed avec le buy button

  // Au scroll
  if ($(".mobile_buy_button_wrapper").length) {
    // si la fenêtre fait moins que 750px
    if (window.innerWidth < 750) {
      // Si le footer est visible
      if (!isInViewport($(".product-form__submit").first().get(0))) {
        // On cache le buy button

        // Si le bouton ".product-form__submit" est au dessus du viewport (une fois qu'on a scrollé), on affiche le buy button
        // Valeur du scroll en hauteur
        var scroll_top = $(window).scrollTop();
        if (scroll_top > $(".product-form__submit").first().offset().top) {
          $(".mobile_buy_button_wrapper").slideDown(200);
        } else {
          $(".mobile_buy_button_wrapper").slideUp(200);
        }
      } else {
        // Sinon on l'affiche
        $(".mobile_buy_button_wrapper").slideUp(200);
      }
    }

    $(window).scroll(function () {
      if (window.innerWidth < 750) {
        // Si le footer est visible
        if (!isInViewport($(".product-form__submit").first().get(0))) {
          // On cache le buy button

          // Si le bouton ".product-form__submit" est au dessus du viewport (une fois qu'on a scrollé), on affiche le buy button
          // Valeur du scroll en hauteur
          var scroll_top = $(window).scrollTop();
          if (scroll_top > $(".product-form__submit").first().offset().top) {
            $(".mobile_buy_button_wrapper").slideDown(200);
          } else {
            $(".mobile_buy_button_wrapper").slideUp(200);
          }
        } else {
          // Sinon on l'affiche
          $(".mobile_buy_button_wrapper").slideUp(200);
        }
      }
    });

    // Au clic sur le bouton ".mobile_buy_button_wrapper button", on scroll la page de façon smooth jusqu'à l'élément "<product-form>"
    $(".mobile_buy_button_wrapper button").click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      // On scroll la page de façon smooth jusqu'à l'élément "<product-form>", de façon a ce que ce dernier soit centré dans la fenêtre
      $("html, body").animate(
        {
          scrollTop: $(".product-form__submit").first().offset().top - window.innerHeight / 2 + $(".product-form__submit").first().outerHeight() / 2,
        },
        200
      );
    });
  }

  // Collection : Contenu Bas de page
  $(".collection_seo_content .toggle_seo_content span").click(function (e) {
    if ($(this).data("action") == "expand") {
      $(this).parents(".collection_seo_content").addClass("expanded");
    } else {
      $(this).parents(".collection_seo_content").removeClass("expanded");
    }
  });

  // Gestion des popins
  $(".popin_overlay").click(function () {
    $("body").removeClass("no-scroll");
    $(".popin_wrapper").fadeOut(400, function () {
      // Suppression du contenu de la popin
      $(".popin").remove();
    });
  });

  $(".popin_overlay *")
    .not(".popin_close")
    .click(function (e) {
      e.stopPropagation();
    });

  // Lien pour fermer la popin
  $(document).on("click", ".popin_close", function (e) {
    $(".popin_overlay").click();
  });

  // Bouton "Esc" pour fermer la popin
  $(document).on("keydown", function (e) {
    if (e.keyCode == 27 && $(".popin_wrapper").is(":visible")) {
      $(".popin_overlay").click();
    }
  });

  // Click sur les liens concernés par la popin
  $("[data-popin=1]").click(function (e) {
    e.stopPropagation();
    e.preventDefault();

    // On récupère la section à loader
    var section = $(this).data("target");
    var fetch_base_url = $(this).data("fetch-base-url") || "";

    // On fecth le contenu de la section
    $.get(fetch_base_url + "/?section_id=" + section, function (data) {
      // On crée la popin
      var html = data;

      // On prepend et on affiche la zone .popin_wrapper avec le contenu de la popin
      $("body").addClass("no-scroll");
      $(".popin_wrapper > div").prepend(html);
      $(".popin_wrapper").fadeIn(400);
    });
  });

  // Custom select
  if ($(".custom-select").length) {
    $(document).on("click", ".custom-select", function (e) {
      e.stopPropagation();
      $(this).find(".select-items").toggleClass("select-hide");
    });

    $(document).on("click", function () {
      $(".custom-select .select-items").addClass("select-hide");
    });

    $(".custom-select .select-items input[type='radio']").on("change", function () {
      $(this).closest(".custom-select").find(".select-selected").text($(this).next().text());
      $(this).closest(".custom-select").find(".select-items").addClass("select-hide");
    });
  }
});

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
